import { Settings, Video, Monitor } from 'lucide-react';

export function StreamSettings({ 
  streamTitle, 
  setStreamTitle, 
  sourceType, 
  setSourceType, 
  isStreaming 
}) {
  return (
    <div className="glass-card p-6">
      <h3 className="font-semibold mb-4 flex items-center gap-2">
        <Settings className="w-5 h-5 text-purple-400" /> Stream Settings
      </h3>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm text-gray-400 mb-2">Stream Title</label>
          <input
            type="text"
            value={streamTitle}
            onChange={(e) => setStreamTitle(e.target.value)}
            disabled={isStreaming}
            placeholder="Enter stream title"
            className="w-full p-3 rounded-lg bg-white/5 border border-white/10 focus:border-purple-500 outline-none disabled:opacity-50"
            data-testid="stream-title-input"
          />
        </div>
        
        <div>
          <label className="block text-sm text-gray-400 mb-2">Source</label>
          <div className="grid grid-cols-2 gap-2">
            <button
              onClick={() => setSourceType('camera')}
              disabled={isStreaming}
              className={`p-3 rounded-lg flex items-center justify-center gap-2 transition-all ${
                sourceType === 'camera' 
                  ? 'bg-purple-500 text-white' 
                  : 'bg-white/5 hover:bg-white/10'
              } ${isStreaming && 'opacity-50 cursor-not-allowed'}`}
              data-testid="source-camera"
            >
              <Video className="w-4 h-4" /> Camera
            </button>
            <button
              onClick={() => setSourceType('screen')}
              disabled={isStreaming}
              className={`p-3 rounded-lg flex items-center justify-center gap-2 transition-all ${
                sourceType === 'screen' 
                  ? 'bg-purple-500 text-white' 
                  : 'bg-white/5 hover:bg-white/10'
              } ${isStreaming && 'opacity-50 cursor-not-allowed'}`}
              data-testid="source-screen"
            >
              <Monitor className="w-4 h-4" /> Screen
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function StreamInfo({ viewerCount, streamId }) {
  return (
    <div className="glass-card p-6">
      <h3 className="font-semibold mb-4">Stream Info</h3>
      <div className="space-y-3">
        <div className="flex justify-between text-sm">
          <span className="text-gray-400">Status</span>
          <span className="text-green-400 flex items-center gap-1">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
            Live
          </span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-400">Viewers</span>
          <span>{viewerCount}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-400">Stream ID</span>
          <span className="text-xs text-gray-500 truncate max-w-[150px]">{streamId}</span>
        </div>
      </div>
    </div>
  );
}

export function StreamTips() {
  return (
    <div className="glass-card p-6 border-yellow-500/30 border">
      <h3 className="font-semibold mb-2 text-yellow-400">Tips</h3>
      <ul className="text-sm text-gray-400 space-y-2">
        <li>• Use good lighting for better video quality</li>
        <li>• Test your audio levels before going live</li>
        <li>• Screen share works great for music production</li>
        <li>• Viewers can watch at /live on your site</li>
      </ul>
    </div>
  );
}
